<template>
  <v-form ref="form" lazy-validation @submit.prevent="onSubmit" class="app-form">
    <v-expansion-panels class="app-expansion-panels"  v-model="panel" >
      <v-expansion-panel @click.stop="changeCollapse" elevation="0" flat="true">
        <v-expansion-panel-header class="app-expansion-panel-header mb-0">
          <h4 class="text">
            <v-icon>filter_alt</v-icon>
            <span>Filtrar Pedidos</span>
          </h4>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="app-expansion-panel-content">
          <v-row class="mt-3">
            <v-col :lg="3" :md="3" :sm="3" :xs="12" class="pt-0">
              <v-text-field
                v-model="table.paginate.input.group"
                placeholder="Ex:. G-1001"
                label="Grupo"
                outlined
                dense
              />
            </v-col>
            <v-col :lg="3" :md="3" :sm="3" :xs="12" class="pt-0">
              <SearchOrderVehiclePlateField v-model="table.paginate.input.plate" />
            </v-col>
            <v-col :lg="3" :md="3" :sm="3" :xs="12" class="pt-0">
              <SearchOrderTypeSelect v-model="table.paginate.input.type_key" />
            </v-col>
            <v-col :lg="3" :md="3" :sm="3" :xs="12" class="pt-0">
              <SearchOrderStatusSelect v-model="table.paginate.input.status" />
            </v-col>
            <v-col :lg="3" :md="3" :sm="3" :xs="12" class="pt-0">
              <SearchOrderValidUntilSelect v-model="table.paginate.input.valid_until" />
            </v-col>

          </v-row>
          <v-divider></v-divider>
          <div class="mt-3 d-flex">
            <v-spacer></v-spacer>
            <v-btn
              outlined
              color="error"
              type="button"
              @click.prevent.stop="clearFilter"
              class="mr-2"
            >
              <v-icon size="14">delete</v-icon>Limpar Filtros
            </v-btn>
            <v-btn depressed color="success" type="submit">Filtrar</v-btn>
          </div>

          <section class="loading" v-if="table.isLoading">
            <v-progress-circular indeterminate color="success"></v-progress-circular>
          </section>
          <div id="endForm"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { StatusPedidoEnum } from "@/models/status-pedido.enum";

import SearchOrderTypeSelect from './SearchOrderTypeSelect.vue';
import SearchOrderStatusSelect from './SearchOrderStatusSelect.vue';
import SearchOrderVehiclePlateField from './SearchOrderVehiclePlateField.vue';
import SearchOrderValidUntilSelect from './SearchOrderValidUntilSelect.vue';

export default {
  name: "OrderSearch",

  components: {
    SearchOrderTypeSelect,
    SearchOrderStatusSelect,
    SearchOrderVehiclePlateField,
    SearchOrderValidUntilSelect
  },
  
  data: () => ({
    panel: null,            
  }),

  computed: {
    ...mapState('order', ['table']),    
  },

  destroyed() {
    this.clear();
  },

  watch: {
    '$route.query'() {
      this.mountedQueryParamsSearch();
    }
  },

  mounted() {      
    this.mountedQueryParamsSearch();
  },

  methods: {
    onSubmit() {
      this.changeQueryParamsSearch();
      this.$vuetify.goTo('#endForm');
    },
    
    clearFilter() {
      this.$refs.form.reset();
      this.clearQueryParamsSearch();
      this.clear();  
      this.search();     
    },

    changeQueryParamsSearch() {
      const input = this.table.paginate.input;               
      this.$router.push({ 
        path: this.$route.path,
        query: { 
          ...this.$route.query,
          ...this.permittedQueryParams().reduce((obj, param) => {
            if (input[param]) {
              obj[param] = input[param];
            }
            return obj;
          }, {})
        } 
      });
    },      

    mountedQueryParamsSearch() {
      const query = this.$route.query;

      this.permittedQueryParams().forEach(param => {
        if (query[param]) {
          this.table.paginate.input[param] = query[param];
        }
      });        
    },

    clearQueryParamsSearch() {
      const query = this.$route.query;
      
      if(Object.keys(query).length === 0) return;
      
      this.$router.push({ 
        path: this.$route.path, 
        query: {} 
      });
    },

    permittedQueryParams() {
      return [
        'type_key',
        'status',
        'company_id',
        'payment_status',
        'inspection_status',
        'plate',
        'group',
        'expiring_in',
        'validity_expired',
        'valid_until',
      ]
    },

    changeCollapse() {},
    ...mapActions('order', { search: 'SEARCH' }),
    ...mapActions('order', { clear: 'CLEAR' }),
    ...mapActions('order', { changePage: 'CHANGE_PAGE' })
  },
};
</script>

<style lang="scss" scoped>
.v-expansion-panel {
  &:before {
    box-shadow: none !important;
  }
}
</style>
